<template>
    <ul :class="classes">
        <li v-for="(item, index) in menuItems" :key="index" class="menu-item">
            <a :href="`${$SiteUrl}/loja/categoria/${item.Slug}`" class="link-term"><i v-if="icone == true" class="fa fa-chevron-right"></i> {{ item.Descricao }}</a>
            
            <i v-if="item.ItensMenu && item.ItensMenu.length > 0" class="fa fa-chevron-right"></i>
            <!-- Componente recursivo -->
            <div v-if="item.ItensMenu && item.ItensMenu.length > 0" class="submenu">
                <MultiLevelMenu :menuItems="item.ItensMenu" />
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'MultiLevelMenu',
    props: [
        'menuItems',
        'classes',
        'icone'
    ]
}
</script>
